import { addDoc, collection, Timestamp } from 'firebase/firestore';
import { db } from './firebase';

export function purchaseRequisitionPath(prId: string): string {
  return `/purchasing?pr=${encodeURIComponent(prId)}`;
}

export async function notifyPurchaseRequisition(params: {
  userId: string;
  title: string;
  message: string;
  prId: string;
  skipUserId?: string;
}): Promise<void> {
  if (!params.userId || params.userId === params.skipUserId) return;
  try {
    await addDoc(collection(db, 'userNotifications'), {
      userId: params.userId,
      type: 'purchase_requisition',
      title: params.title,
      message: params.message,
      read: false,
      isPriority: true,
      link: purchaseRequisitionPath(params.prId),
      sourceId: params.prId,
      createdAt: Timestamp.now(),
    });
  } catch (error) {
    console.error('[notifyPurchaseRequisition]', error);
  }
}

export function describePurchase(input: {
  amount: number;
  title: string;
  vendorName?: string;
  costLabel?: string;
}): string {
  const money = input.amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2,
  });
  const vendor = input.vendorName?.trim() ? ` from ${input.vendorName.trim()}` : '';
  const job = input.costLabel?.trim() ? ` · ${input.costLabel.trim()}` : '';
  return `${money} — ${input.title.trim() || 'Purchase'}${vendor}${job}`;
}
